import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueMobileDetection from "vue-mobile-detection";
import './assets/main.css'
// 加入版本號檢查，強制重新載入
const APP_VERSION = Date.now().toString()
const STORAGE_VERSION_KEY = 'app_version'
// 檢查版本號
const storedVersion = localStorage.getItem(STORAGE_VERSION_KEY)

if (storedVersion !== APP_VERSION) {
  // 清除所有快取
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name)
      })
    })
  }
  
  // 清除 localStorage 中的舊資料（保留重要資料）
  const importantKeys = ['selectedLanguage'] // 保留的重要資料
  const tempData = {}
  
  importantKeys.forEach(key => {
    const value = localStorage.getItem(key)
    if (value) {
      tempData[key] = value
    }
  })
  
  localStorage.clear()
  
  // 恢復重要資料
  Object.keys(tempData).forEach(key => {
    localStorage.setItem(key, tempData[key])
  })
  
  // 更新版本號
  localStorage.setItem(STORAGE_VERSION_KEY, APP_VERSION)
  
  console.log('應用程式已更新，快取已清除')
}

const app = createApp(App).use(store).use(router).use(VueMobileDetection)
// 關閉 Vue 的警告和錯誤提示
app.config.warnHandler = () => {}
app.config.errorHandler = () => {}
app.mount('#app')
